
export default {
  name: 'AppSpinner'
};
